import { HttpClient, HttpContext } from '@angular/common/http'
import { Injectable } from '@angular/core'
import {
  ERROR_INTERCEPTOR_BYPASS,
  HANDLE_ERROR_AND_THROW,
  HELIOS_COMMAND_HTTP_TOKEN,
} from '@helios/utils'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import {
  BULK_EXT_TRAN_LIMIT,
  BulkExtTranSetValues,
  BulkExternalTransactionActionResult,
  BulkExternalTransactionActionType,
  BulkExternalTransactionsGetRequest,
  BulkExternalTransactionsGetResponse,
} from '../../models/bulk-external-transactions.model'
import { ExternalTransactionAvailableActions } from '../../models/external-transaction'

export const BULK_EXT_TX_URL = `helios-bulk-ext-transactions`
export const BULK_EXT_TX_SET_VALUES_URL = `${BULK_EXT_TX_URL}/setValues`

@Injectable({
  providedIn: 'root',
})
export class BulkExternalTransactionsService {
  constructor(private readonly http: HttpClient) {}

  getBulkExternalTransactions(
    request: BulkExternalTransactionsGetRequest,
  ): Observable<BulkExternalTransactionsGetResponse> {
    return this.http
      .post<BulkExternalTransactionsGetResponse>(BULK_EXT_TX_URL, request, {
        params: {
          maxBulkExtTrans: BULK_EXT_TRAN_LIMIT,
        },
        context: new HttpContext()
          .set(ERROR_INTERCEPTOR_BYPASS, [503])
          .set(HANDLE_ERROR_AND_THROW, true),
      })
      .pipe(
        map(response => {
          // Lowercase all availableActions for each transaction
          response?.data.forEach(tx => {
            tx.availableActions = tx.availableActions.map(action =>
              action.toLowerCase(),
            ) as ExternalTransactionAvailableActions[]
          })
          return response
        }),
      )
  }

  getBulkExtTranSetValues(): Observable<BulkExtTranSetValues> {
    return this.http.get<BulkExtTranSetValues>(BULK_EXT_TX_SET_VALUES_URL)
  }

  updateTransactions(
    extTranIds: number[],
    type: BulkExternalTransactionActionType,
  ): Promise<BulkExternalTransactionActionResult> {
    return this.http
      .put<BulkExternalTransactionActionResult>(
        BULK_EXT_TX_URL,
        {
          extTranIds,
          type,
        },
        {
          context: new HttpContext().set(HELIOS_COMMAND_HTTP_TOKEN, true),
        },
      )
      .toPromise()
  }
}
